import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiListDataService } from './api.list-data.service';
import { UserByRoleAndOrgDataModel } from 'core/models';

@Injectable({
    providedIn: 'root',
})
export class ApiUserByRoleAndOrgService extends ApiListDataService<UserByRoleAndOrgDataModel, any> {
    constructor(http: HttpClient) {
        super(http, '/User/ByRoleAndOrg');
    }
}
